module.exports = __webpack_public_path__ + "img/jiayin.e25228bc.png";